import stimulus from '../stimulus';
import PriceIndicationsLoaderController from './price_indications_loader_controller';

stimulus.register('journey-search--price-indications-loader', PriceIndicationsLoaderController);
